/**
 * The repair function can't fix a value so delete it instead
 */
export class VerifierDrop extends Error {
    constructor() {
        super("verifier drop");
        this.name = this.constructor.name;
    }
}
/**
 * The repair function can't fix a value so delete the parent object instead
 */
export class VerifierDropParent extends Error {
    constructor() {
        super("verifier drop parent");
        this.name = this.constructor.name;
    }
}
export function addReducer(action, handler) {
    return {
        [action]: handler,
    };
}
